import React from 'react';

import { Box, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// Import all logo options to make them available
import AxleLogo from '../images/logo/axle logo.png';
import AxleWhiteLogo from '../images/logo/axle white logo.png';
import CatenaLogo from '../images/logo/catena_logo.png';
import CatenaWhiteLogo from '../images/logo/catena_white_logo.png';

// Map of logo names to the actual imported images
const logoMap: Record<string, any> = {
  'logo/axle logo.png': AxleLogo,
  'logo/axle white logo.png': AxleWhiteLogo,
  'logo/catena_logo.png': CatenaLogo,
  'logo/catena_white_logo.png': CatenaWhiteLogo,
};

const Footer = () => {
  const theme = useTheme();

  // Get branding from theme
  const branding = (theme as any).custom?.branding || {
    poweredBy: true,
    poweredByText: 'Powered by',
    logoSrc: 'logo/catena_logo.png',
    logoAlt: 'Catena',
    logoHeight: '3vh',
    logoUrl: 'https://www.catenaclearing.io',
    textColor: theme.palette.text.secondary,
  };

  // If poweredBy is set to false, don't show the footer
  if (branding.poweredBy === false) {
    return null;
  }

  // Resolve the logo from the map or use the default
  const logo =
    (typeof branding.logoSrc === 'string' && logoMap[branding.logoSrc]) ||
    CatenaLogo;

  return (
    <Box
      component='footer'
      sx={{
        display: { xs: 'none', sm: 'block' }, // Hide on mobile, show on desktop
        padding: {
          xs: 'calc(16px + env(safe-area-inset-top)) calc(16px + env(safe-area-inset-right)) calc(16px + env(safe-area-inset-bottom)) calc(16px + env(safe-area-inset-left))',
          sm: theme.spacing(3.75),
        },
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        textAlign: 'center',
        backgroundColor: 'transparent',
        zIndex: -1, // Change to negative z-index to stay below content
        pointerEvents: 'none',
      }}
    >
      <Grid
        container
        item
        direction='row'
        alignItems='center'
        justifyContent='center'
        spacing={{ xs: 0.5, sm: 1 }}
        sx={{
          mb: 0,
          // Re-enable pointer events for interactive elements
          '& > *': {
            pointerEvents: 'auto',
          },
        }}
      >
        <Grid item sx={{ padding: 0 }}>
          <Typography
            variant='caption'
            sx={{
              color: branding.textColor,
              fontSize: { xs: '11px', sm: '12px' },
              lineHeight: { xs: '14px', sm: '16px' },
              fontWeight: 400,
            }}
          >
            {branding.poweredByText}{' '}
          </Typography>
        </Grid>
        <Grid item sx={{ padding: 0 }}>
          <a
            target='_blank'
            href={branding.logoUrl}
            rel='noopener noreferrer'
            style={{ display: 'inline-block' }}
          >
            <Box
              component='img'
              sx={{
                height: {
                  xs: '16px',
                  sm: branding.logoHeight,
                },
                maxHeight: { xs: '16px', sm: 'none' },
                width: 'auto',
                verticalAlign: 'middle',
              }}
              alt={branding.logoAlt}
              src={logo}
            />
          </a>
        </Grid>
      </Grid>
      {/* <Typography variant="caption" sx={{ color: textColor }}>
        &copy; {new Date().getFullYear()} Catena
      </Typography> */}
    </Box>
  );
};

export default Footer;
